import gql from 'graphql-tag'

const mutation = gql`
mutation copyCashRegisterSettings ($id: ID!){
  cashAssist {
    copyCashRegisterSettings(id: $id) {
    	id
    	status
    }
   }
  }
`
export default mutation
